var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { sdsCustomElement } from '../../utilities/custom-components';
import { SdsInputBase } from '../_sds-input-base';
import styles from './sds-input-multiselect.lit.scss';
import { SdsIcon } from '../../icon/sds-icon.lit';
/**
 * Control that represents select input.
 *
 * @tag sds-input-multiselect
 */
let SdsInputMultiselect = (() => {
    var _SdsInputMultiselect_opened_accessor_storage, _SdsInputMultiselect__input_accessor_storage, _SdsInputMultiselect__labels_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-input-multiselect')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputBase;
    let _opened_decorators;
    let _opened_initializers = [];
    let _opened_extraInitializers = [];
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    let __labels_decorators;
    let __labels_initializers = [];
    let __labels_extraInitializers = [];
    var SdsInputMultiselect = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInputMultiselect_opened_accessor_storage.set(this, __runInitializers(this, _opened_initializers, false));
            this._currentType = (__runInitializers(this, _opened_extraInitializers), 'select');
            _SdsInputMultiselect__input_accessor_storage.set(this, __runInitializers(this, __input_initializers, void 0));
            _SdsInputMultiselect__labels_accessor_storage.set(this, (__runInitializers(this, __input_extraInitializers), __runInitializers(this, __labels_initializers, new Map())));
            this.onInputClick = (__runInitializers(this, __labels_extraInitializers), (e) => {
                if (!(e.target instanceof SdsIcon && e.target.id === 'sds-input-multiselect-caret')) {
                    this.dispatchEvent(new CustomEvent(SdsInputMultiselect.INPUT_CLICKED_EVENT, {
                        detail: { value: this.value },
                        bubbles: false,
                        composed: false,
                    }));
                }
            });
            this.handleLabelClose = (event) => {
                const details = event.detail;
                this.dispatchEvent(new CustomEvent(SdsInputMultiselect.LABEL_CLOSED_EVENT, {
                    detail: {
                        name: details.name,
                        identifier: details.identifier,
                    },
                    bubbles: false,
                    composed: false,
                }));
            };
            this.handleLabelClick = (event) => {
                if (this.opened) {
                    const identifier = event.detail.identifier;
                    if (identifier) {
                        this.getInput().focus();
                        this.focusLabel(identifier);
                    }
                }
                else {
                    this.onInputClick(event);
                }
            };
            this.handleClear = (event) => {
                this.value = this.emptyValue();
                this.clearLabels();
                this.dispatchEvent(new CustomEvent(SdsInputMultiselect.CLEARED_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
                event.stopPropagation();
            };
            this.handleKeyDown = (event) => {
                switch (event.code) {
                    case 'Enter':
                        // Only prevent Enter when button is NOT focused AND menu is NOT open
                        // When menu is open, let Enter pass through to select menu items
                        if (!this.buttonFocused && !this.opened) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        break;
                    case 'Space':
                        if (!this.disabled && !this.opened) {
                            event.preventDefault();
                            event.stopPropagation();
                            this.dispatchEvent(new CustomEvent(SdsInputMultiselect.CARET_CHANGED_EVENT, {
                                detail: { value: this.value },
                                bubbles: false,
                                composed: false,
                            }));
                        }
                        break;
                    case 'ArrowUp':
                    case 'ArrowDown':
                        event.preventDefault();
                        break;
                    case 'ArrowLeft':
                    case 'ArrowRight':
                        if (this.hasFocusedLabel()) {
                            event.preventDefault();
                        }
                        break;
                }
            };
            this.focusLabel = (identifier) => {
                // Clear focus from all labels manually to avoid extra requestUpdate
                Array.from(this._labels.values()).forEach(item => (item.focused = false));
                // Set focus on target label
                const label = this._labels.get(identifier);
                if (label) {
                    label.focused = true;
                }
                this.requestUpdate();
            };
            this.handleLabelFocus = (identifier) => {
                this.focusLabel(identifier);
            };
            this.handleLabelBlur = (identifier) => {
                const label = this._labels.get(identifier);
                if (label) {
                    label.focused = false;
                }
                this.requestUpdate();
            };
            this.handleMultiselectCaret = () => {
                this.dispatchEvent(new CustomEvent(SdsInputMultiselect.CARET_CHANGED_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            };
        }
        get opened() { return __classPrivateFieldGet(this, _SdsInputMultiselect_opened_accessor_storage, "f"); }
        set opened(value) { __classPrivateFieldSet(this, _SdsInputMultiselect_opened_accessor_storage, value, "f"); }
        get _input() { return __classPrivateFieldGet(this, _SdsInputMultiselect__input_accessor_storage, "f"); }
        set _input(value) { __classPrivateFieldSet(this, _SdsInputMultiselect__input_accessor_storage, value, "f"); }
        get _labels() { return __classPrivateFieldGet(this, _SdsInputMultiselect__labels_accessor_storage, "f"); }
        set _labels(value) { __classPrivateFieldSet(this, _SdsInputMultiselect__labels_accessor_storage, value, "f"); }
        deleteLabel(identifier) {
            var _a;
            if (this._labels.has(identifier)) {
                const wasFocused = (_a = this._labels.get(identifier)) === null || _a === void 0 ? void 0 : _a.focused;
                const labelKeys = Array.from(this._labels.keys());
                const deletedIndex = labelKeys.indexOf(identifier);
                // Delete the label first
                this._labels.delete(identifier);
                // Handle focus after deletion
                if (wasFocused) {
                    const remainingLabels = this._labels.size;
                    if (remainingLabels === 0) {
                        // No labels left - focus input
                        setTimeout(() => {
                            this.getInput().focus();
                        }, 0);
                    }
                    else {
                        // Focus next appropriate label
                        const remainingKeys = Array.from(this._labels.keys());
                        let nextFocusIdentifier;
                        if (deletedIndex >= remainingLabels) {
                            // Deleted label was at the end, focus the new last label
                            nextFocusIdentifier = remainingKeys[remainingLabels - 1];
                        }
                        else {
                            // Focus the label that is now at the same position
                            nextFocusIdentifier = remainingKeys[deletedIndex];
                        }
                        // Set focus on the next label without calling cleanLabelsFocus
                        const nextLabel = this._labels.get(nextFocusIdentifier);
                        if (nextLabel) {
                            nextLabel.focused = true;
                            // Use setTimeout to avoid scheduling updates during update cycle
                            setTimeout(() => {
                                this.focusLabelElement(nextFocusIdentifier);
                            }, 0);
                        }
                    }
                }
                this.requestUpdate();
            }
        }
        addLabel(identifier, label) {
            if (!this._labels.has(identifier)) {
                this._labels.set(identifier, label);
                this.requestUpdate();
            }
        }
        clearLabels() {
            this._labels.clear();
            this.requestUpdate();
        }
        cleanLabelsFocus() {
            Array.from(this._labels.values()).forEach(item => (item.focused = false));
            this.requestUpdate();
        }
        focusLabelElement(identifier) {
            var _a, _b, _c;
            // Focus the actual DOM element - try multiple selectors
            let labelElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`sds-label[identifier="${identifier}"]`);
            if (!labelElement) {
                labelElement = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(`sds-label-avatar[identifier="${identifier}"]`);
            }
            // If still not found, try without quotes (in case it's a property)
            if (!labelElement) {
                const allLabels = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelectorAll('sds-label, sds-label-avatar');
                for (const label of allLabels || []) {
                    const labelWithIdentifier = label;
                    if (labelWithIdentifier.identifier === identifier) {
                        labelElement = label;
                        break;
                    }
                }
            }
            if (labelElement) {
                labelElement.focus();
            }
        }
        shiftLabelFocusRight() {
            if (this.hasFocusedLabel()) {
                const identifier = this.getFocusedLabelIdentifier();
                if (identifier) {
                    const index = Array.from(this._labels.keys()).indexOf(identifier);
                    const labelKeys = Array.from(this._labels.keys());
                    const values = Array.from(this._labels.values());
                    if (index !== values.length - 1) {
                        values[index].focused = false;
                        values[index + 1].focused = true;
                        // Focus the next label element
                        const nextIdentifier = labelKeys[index + 1];
                        this.focusLabelElement(nextIdentifier);
                    }
                    else {
                        values[index].focused = false;
                        this.getInput().focus();
                    }
                    this.requestUpdate();
                }
            }
        }
        shiftLabelFocusLeft() {
            if (this._labels.size !== 0) {
                if (this.hasFocusedLabel()) {
                    const identifier = this.getFocusedLabelIdentifier();
                    if (identifier) {
                        const index = Array.from(this._labels.keys()).indexOf(identifier);
                        const labelKeys = Array.from(this._labels.keys());
                        const values = Array.from(this._labels.values());
                        if (index !== 0) {
                            values[index].focused = false;
                            values[index - 1].focused = true;
                            // Focus the previous label element
                            const prevIdentifier = labelKeys[index - 1];
                            this.focusLabelElement(prevIdentifier);
                            this.requestUpdate();
                        }
                    }
                }
                else if (this._input.selectionEnd === 0) {
                    const labelKeys = Array.from(this._labels.keys());
                    const values = Array.from(this._labels.values());
                    values[values.length - 1].focused = true;
                    // Focus the last label element
                    const lastIdentifier = labelKeys[labelKeys.length - 1];
                    this.focusLabelElement(lastIdentifier);
                    this.requestUpdate();
                }
            }
        }
        getFocusedLabelIdentifier() {
            for (const [key, value] of this._labels.entries()) {
                if (value.focused) {
                    return key;
                }
            }
        }
        getInput() {
            return this._input;
        }
        setCursorToEnd() {
            const input = this.getInput();
            if (input) {
                const length = input.value.length;
                input.setSelectionRange(length, length);
            }
        }
        render() {
            return html `
            <div class="${this.getClasses()}">
                <div class="sds-input-multiselect__wrapper" @click="${this.onInputClick}">
                    ${this.renderLabels()} ${this.renderInput(this._currentType)}
                    ${this.renderClear()} ${this.renderCaret()}
                </div>
                ${this.renderSelectedItemsDescription()} ${this.renderMessages()}
            </div>
        `;
        }
        getClasses() {
            return classMap({
                'sds-input-multiselect': true,
                'sds-input-multiselect--focused': this.focused || this.buttonFocused,
                'sds-input-multiselect--disabled': this.disabled,
                'sds-input-multiselect--invalid': this.invalid,
            });
        }
        renderLabels() {
            return html `
            ${[...this._labels.entries()].map(([key, value]) => {
                const labelTabindex = this.shouldLabelsBeTabble() ? '0' : '-1';
                if (value.withAvatar) {
                    return html `
                        <sds-label-avatar
                            .name="${value.name}"
                            .role="${value.role}"
                            .avatar-icon="${value.icon}"
                            .src="${value.src}"
                            .identifier="${key}"
                            ?focused="${value.focused}"
                            .isInMultiselectInput="${true}"
                            size="lg"
                            action
                            tabindex="${labelTabindex}"
                            @focus="${() => this.handleLabelFocus(key)}"
                            @blur="${() => this.handleLabelBlur(key)}"
                            @sds.label.closed="${this.handleLabelClose}"
                            @sds.label.click="${this.handleLabelClick}"
                        ></sds-label-avatar>
                    `;
                }
                return html `
                    <sds-label
                        .name="${value.name}"
                        .icon="${value.icon}"
                        .identifier="${key}"
                        ?focused="${value.focused}"
                        .isInMultiselectInput="${true}"
                        tabindex="${labelTabindex}"
                        size="lg"
                        action
                        @focus="${() => this.handleLabelFocus(key)}"
                        @blur="${() => this.handleLabelBlur(key)}"
                        @sds.label.closed="${this.handleLabelClose}"
                        @sds.label.click="${this.handleLabelClick}"
                    ></sds-label>
                `;
            })}
        `;
        }
        renderInput(type) {
            return html `
            <input
                id="${this.unique}"
                class="sds-input-multiselect__element"
                autocomplete="off"
                tabindex="0"
                ?disabled="${this.disabled}"
                .placeholder="${this.placeholder}"
                .value="${this.value}"
                .type="${type}"
                role="combobox"
                aria-autocomplete="list"
                aria-haspopup="listbox"
                aria-expanded="${this.opened ? 'true' : 'false'}"
                aria-label="Multiselect combobox"
                aria-describedby="input-multiselect-status"
                @input="${() => this.handleInput()}"
                @focus="${() => this.handleFocus()}"
                @blur="${() => this.handleBlur()}"
                @change="${() => this.handleChanged()}"
                @keydown="${this.handleKeyDown}"
            />
        `;
        }
        renderCaret() {
            if (this.opened) {
                return html `
                <sds-icon
                    id="sds-input-multiselect-caret"
                    class="sds-input-multiselect__caret"
                    @click="${this.handleMultiselectCaret}"
                    name="arrow_up_small"
                    size="24"
                ></sds-icon>
            `;
            }
            else {
                return html `
                <sds-icon
                    id="sds-input-multiselect-caret"
                    class="sds-input-multiselect__caret"
                    @click="${this.handleMultiselectCaret}"
                    name="arrow_down_small"
                    size="24"
                ></sds-icon>
            `;
            }
        }
        renderClear() {
            if (this.showClear()) {
                return html `
                <sds-button
                    class="sds-input-multiselect__actions"
                    type="tertiary"
                    icon="close_circle"
                    size="md"
                    aria-label="Clear all selected items"
                    @focus="${() => this.handleActionFocus()}"
                    @blur="${() => this.handleActionBlur()}"
                    @click="${this.handleClear}"
                    @keydown="${(event) => {
                    // Manually handle Enter key since native button behavior isn't working
                    // But only when menu is closed - when menu is open, let Enter select menu items
                    if (event.code === 'Enter' && !this.opened) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.handleClear(event);
                    }
                }}"
                ></sds-button>
            `;
            }
        }
        handleBlur() {
            if (!this.opened) {
                this.focused = false;
            }
        }
        showClear() {
            return (this._labels && this._labels.size !== 0) || super.showClear();
        }
        renderSelectedItemsDescription() {
            const selectedCount = this._labels.size;
            let statusText = '';
            if (selectedCount > 0) {
                const selectedItemNames = Array.from(this._labels.values()).map(label => label.name);
                statusText = `${selectedCount} item${selectedCount === 1 ? '' : 's'} selected: ${selectedItemNames.join(', ')}`;
            }
            else {
                statusText = 'No items selected';
            }
            return html `
            <div id="input-multiselect-status" class="sr-only" aria-live="off" role="status">
                ${statusText}
            </div>
        `;
        }
        renderHint() {
            if (this.hint && !this.invalid) {
                return html ` <div class="sds-input-multiselect__hint">${this.hint}</div> `;
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        emptyValue() {
            return '';
        }
        convertValue(value) {
            return value;
        }
        hasFocusedLabel() {
            var _a, _b;
            return (_b = (_a = Array.from(this._labels.values()).find(value => value.focused)) === null || _a === void 0 ? void 0 : _a.focused) !== null && _b !== void 0 ? _b : false;
        }
        shouldLabelsBeTabble() {
            // Labels should be tabbable when:
            // 1. Input is focused OR
            // 2. Any label is focused
            const inputFocused = this.focused;
            const labelFocused = this.hasFocusedLabel();
            return inputFocused || labelFocused;
        }
    };
    _SdsInputMultiselect_opened_accessor_storage = new WeakMap();
    _SdsInputMultiselect__input_accessor_storage = new WeakMap();
    _SdsInputMultiselect__labels_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInputMultiselect");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _opened_decorators = [property({ attribute: false })];
        __input_decorators = [query('input.sds-input-multiselect__element')];
        __labels_decorators = [state()];
        __esDecorate(_classThis, null, _opened_decorators, { kind: "accessor", name: "opened", static: false, private: false, access: { has: obj => "opened" in obj, get: obj => obj.opened, set: (obj, value) => { obj.opened = value; } }, metadata: _metadata }, _opened_initializers, _opened_extraInitializers);
        __esDecorate(_classThis, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
        __esDecorate(_classThis, null, __labels_decorators, { kind: "accessor", name: "_labels", static: false, private: false, access: { has: obj => "_labels" in obj, get: obj => obj._labels, set: (obj, value) => { obj._labels = value; } }, metadata: _metadata }, __labels_initializers, __labels_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInputMultiselect = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CARET_CHANGED_EVENT = 'sds.input.multiselect.caret.changed';
    _classThis.CLEARED_EVENT = 'sds.input.multiselect.cleared';
    _classThis.INPUT_CLICKED_EVENT = 'sds.input.multiselect.input.clicked';
    _classThis.LABEL_CLOSED_EVENT = 'sds.input.multiselect.label.closed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInputMultiselect = _classThis;
})();
export { SdsInputMultiselect };
